import { all, put, takeLatest } from "redux-saga/effects";

import {
  getDistrictsSuccess,
  getDistrictsFail,
  getCirclesSuccess,
  getCirclesFail,
  getLocalitiesSuccess,
  getLocalitiesFail,
  getLocalityCodesSuccess,
  getLocalityCodesFail,
  getWardsSuccess,
  getWardsFail,
  getBlocksSuccess,
  getBlocksFail,
  getBuildingTypesSuccess,
  getBuildingTypesFail,
  getPropertyTypesSuccess,
  getPropertyTypesFail,
  getPropertyClassificationsSuccess,
  getPropertyClassificationsFail,
  getMouzasSuccess,
  getMouzasFail,
  getHighwaysSuccess,
  getHighwaysFail,
  getInspectorsSuccess,
  getInspectorsFail,
  getEtoCirclesSuccess,
  getEtoCirclesFail,
  getZonesSuccess,
  getZonesFail,
  getUserByZoneOrCircleSuccess,
  getUserByZoneOrCircleFail,
  getUsersSuccess,
  getUsersFail,
  getEtoZonesFail,
  getEtoZonesSuccess,
  getCirclesByZoneFail,
  getCirclesByZoneSuccess,
  getTisByCircleSuccess,
  getTisByCircleZoneFail,
  getBanksSuccess,
  getBanksFail,
  getBranchesSuccess,
  getBranchesFail,
  getCircleOrZoneOfDistrictSuccess,
  getCircleOrZoneOfDistrictFail,
  getAdminsSuccess,
  getAdminsFail,
} from "../actionCreators/DropDown";
import { doGet } from "../utils/request";

function* getBuildingTypes() {
  try {
    const response = yield doGet(`/dropdowns/buildingTypes`);

    yield put(getBuildingTypesSuccess(response.data));
  } catch (err) {
    yield put(getBuildingTypesFail(err.response.data.message || err.message));
    yield put(getBuildingTypesFail());
  }
}

function* getPropertyTypes() {
  try {
    const response = yield doGet(`/dropdowns/propertyTypes`);

    yield put(getPropertyTypesSuccess(response.data));
  } catch (err) {
    yield put(getPropertyTypesFail(err.response.data.message || err.message));
    yield put(getPropertyTypesFail());
  }
}
function* getPropertyClassifications({ obj }) {
  try {
    let response;
    response = yield doGet(
      `/dropdowns/classifications?khasra_number=${obj?.valuation_data_id || ""}`
    );

    yield put(getPropertyClassificationsSuccess(response?.data));
  } catch (err) {
    yield put(
      getPropertyClassificationsFail(
        err?.response?.data?.message || err?.message
      )
    );
    yield put(getPropertyClassificationsFail());
  }
}

function* getLocalities({ obj }) {
  try {
    const response = yield doGet(
      `/dropdowns/locality?circle_id=${obj.circle_id}`
    );

    yield put(getLocalitiesSuccess(response.data));
  } catch (err) {
    yield put(getLocalitiesFail(err.response.data.message || err.message));
    yield put(getLocalitiesFail());
  }
}
function* getMouzas() {
  try {
    const response = yield doGet(`/dropdowns/mouzas`);

    yield put(getMouzasSuccess(response.data));
  } catch (err) {
    yield put(getMouzasFail(err.response.data.message || err.message));
    yield put(getMouzasFail());
  }
}
function* getHighways({ obj }) {
  try {
    let url;
    if (obj?.circle_id) {
      url = `/dropdowns/highways?circle_id=${obj?.circle_id}`;
    } else {
      url = `/dropdowns/highways`;
    }
    const response = yield doGet(url);

    yield put(getHighwaysSuccess(response.data));
  } catch (err) {
    yield put(getHighwaysFail(err.response.data.message || err.message));
    yield put(getHighwaysFail());
  }
}
function* getDistricts() {
  try {
    const response = yield doGet(`/dropdowns/districts`);

    yield put(getDistrictsSuccess(response.data));
  } catch (err) {
    yield put(getDistrictsFail(err.response.data.message || err.message));
    yield put(getDistrictsFail());
  }
}
function* getAdmins() {
  try {
    const response = yield doGet(`/dropdowns/admins`);
    yield put(getAdminsSuccess(response.data));
  } catch (err) {
    yield put(getAdminsFail(err.response.data.message || err.message));
    yield put(getAdminsFail());
  }
}
function* getCircles() {
  try {
    const response = yield doGet(`/dropdowns/circles`);

    yield put(getCirclesSuccess(response.data));
  } catch (err) {
    yield put(getCirclesFail(err.response.data.message || err.message));
    yield put(getCirclesFail());
  }
}

function* getLocalityCodes({ obj }) {
  try {
    const response = yield doGet(
      `/dropdowns/localityCode?locality_id=${obj.locality_id}`
    );

    yield put(getLocalityCodesSuccess(response.data));
  } catch (err) {
    yield put(getLocalityCodesFail(err.response.data.message || err.message));
    yield put(getLocalityCodesFail());
  }
}

function* getWards({ obj }) {
  try {
    const response = yield doGet(
      `/dropdowns/ward?locality_code_id=${obj.locality_code_id}`
    );

    yield put(getWardsSuccess(response.data));
  } catch (err) {
    yield put(getWardsFail(err.response.data.message || err.message));
    yield put(getWardsFail());
  }
}

function* getBlocks({ obj }) {
  try {
    const response = yield doGet(`/dropdowns/block?ward_id=${obj.ward_id}`);

    yield put(getBlocksSuccess(response.data));
  } catch (err) {
    yield put(getBlocksFail(err.response.data.message || err.message));
    yield put(getBlocksFail());
  }
}
function* getInspectors() {
  try {
    const response = yield doGet(`/dropdowns/inspectors`);
    yield put(getInspectorsSuccess(response.data));
  } catch (err) {
    yield put(getInspectorsFail(err.response.data.message || err.message));
    yield put(getInspectorsFail());
  }
}
function* getEtoCircles() {
  try {
    const response = yield doGet(`/dropdowns/etoCircles`);
    yield put(getEtoCirclesSuccess(response.data));
  } catch (err) {
    yield put(getEtoCirclesFail(err.response.data.message || err.message));
    yield put(getEtoCirclesFail());
  }
}
function* getZones({ obj }) {
  try {
    const response = yield doGet(
      `/user/TICircles?inspector_id=${obj.inspector_id}`
    );
    yield put(getZonesSuccess(response.data));
  } catch (err) {
    yield put(getZonesFail(err.response.data.message || err.message));
    yield put(getZonesFail());
  }
}

function* getUserbyZoneOrCircle({ obj }) {
  try {
    const response = yield doGet(
      `/dropdowns/users?id=${obj.id}&user=${obj.user}`
    );
    yield put(getUserByZoneOrCircleSuccess(response.data));
  } catch (err) {
    yield put(
      getUserByZoneOrCircleFail(err.response.data.message || err.message)
    );
    yield put(getUserByZoneOrCircleFail());
  }
}
function* getUsers({ obj }) {
  try {
    const response = yield doGet(`/user/user?user_id=${obj.user_id}`);
    yield put(getUsersSuccess(response.data));
  } catch (err) {
    yield put(getUsersFail(err.response.data.message || err.message));
    yield put(getUsersFail());
  }
}
function* getEtoZones({ obj }) {
  try {
    const response = yield doGet(`/dropdowns/etoZones`);
    yield put(getEtoZonesSuccess(response.data));
  } catch (err) {
    yield put(getEtoZonesFail(err.response.data.message || err.message));
    yield put(getEtoZonesFail());
  }
}
function* getCirclesByZone({ obj }) {
  try {
    const response = yield doGet(
      `/dropdowns/circlesInZone?zone_id=${obj.zone_id}`
    );
    yield put(getCirclesByZoneSuccess(response.data));
  } catch (err) {
    yield put(getCirclesByZoneFail(err.response.data.message || err.message));
    yield put(getCirclesByZoneFail());
  }
}

function* getTisByCircle({ obj }) {
  try {
    const response = yield doGet(`/dropdowns/TIByCircle/${obj.circleId}`);
    yield put(getTisByCircleSuccess(response.data));
  } catch (err) {
    yield put(getTisByCircleZoneFail(err.response.data.message || err.message));
    yield put(getTisByCircleZoneFail());
  }
}
function* getBanks() {
  try {
    const response = yield doGet(`/dropdowns/banks`);
    yield put(getBanksSuccess(response.data));
  } catch (err) {
    yield put(getBanksFail(err.response.data.message || err.message));
    yield put(getBanksFail());
  }
}
function* getBranches({ obj }) {
  try {
    const response = yield doGet(
      `/dropdowns/branches?bank_name=${obj.bank_id}`
    );
    yield put(getBranchesSuccess(response.data));
  } catch (err) {
    yield put(getBranchesFail(err.response.data.message || err.message));
    yield put(getBranchesFail());
  }
}
function* getCircleOrZoneOfDistrict({ obj }) {
  try {
    let response;
    if (obj.type === "zone") {
      response = yield doGet(
        `/dropdowns/getZonesOfDistrict?districtId=${obj.district_id}`
      );
    } else if (obj.type === "circle") {
      response = yield doGet(
        `/dropdowns/getCirclesOfDistrict?districtId=${obj.district_id}`
      );
    }
    yield put(getCircleOrZoneOfDistrictSuccess(response.data));
  } catch (err) {
    yield put(
      getCircleOrZoneOfDistrictFail(err.response.data.message || err.message)
    );
    yield put(getCircleOrZoneOfDistrictFail());
  }
}

export default function* watcher() {
  yield all([
    takeLatest("GET_BUILDING_TYPES", getBuildingTypes),
    takeLatest("GET_ADMINS", getAdmins),
    takeLatest("GET_PROPERTY_TYPES", getPropertyTypes),
    takeLatest("GET_PROPERTY_CLASSIFICATIONS", getPropertyClassifications),
    takeLatest("GET_LOCALITIES", getLocalities),
    takeLatest("GET_DISTRICTS", getDistricts),
    takeLatest("GET_MOUZAS", getMouzas),
    takeLatest("GET_HIGHWAYS", getHighways),
    takeLatest("GET_CIRCLES", getCircles),
    takeLatest("GET_LOCALITY_CODES", getLocalityCodes),
    takeLatest("GET_WARDS", getWards),
    takeLatest("GET_BLOCKS", getBlocks),
    takeLatest("GET_INSPECTORS", getInspectors),
    takeLatest("GET_ETO_CIRCLES", getEtoCircles),
    takeLatest("GET_ZONES", getZones),
    takeLatest("GET_USER_BY_ZONE_OR_CIRCLE", getUserbyZoneOrCircle),
    takeLatest("GET_USERS", getUsers),
    takeLatest("GET_ETO_ZONES", getEtoZones),
    takeLatest("GET_CIRCLES_BY_ZONE", getCirclesByZone),
    takeLatest("GET_TIS_BY_CIRCLE", getTisByCircle),
    takeLatest("GET_BANKS", getBanks),
    takeLatest("GET_BRANCHES", getBranches),
    takeLatest("GET_CIRCLE_OR_ZONE_OF_DISTRICT", getCircleOrZoneOfDistrict),
  ]);
}
